<ul class="flex mb-0 list-none flex-wrap pt-3 pb-0 flex-row ">
    @for(corpTab of corpTabList; track corpTab.title) {
        <li class="-mb-px mr-2 last:mr-0 flex-auto text-center"
            [ngClass]="{'text-primary bg-white': !corpTab.active, 'text-white bg-primary': corpTab.active}"
            (click)="selectTab(corpTab)" 
            [class.active]="corpTab.active">
        <!-- <a class="cursor-pointer text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal">{{corpTab.title}}</a> -->
        <a
      class="cursor-pointer block px-5 py-2 font-semibold rounded-t-lg
             transition-colors duration-200
             text-gray-600 dark:text-gray-300
             hover:text-primary-600 dark:hover:text-primary-400"
      [ngClass]="{
        'bg-white text-primary-700 dark:bg-gray-800 dark:text-primary-400 border border-b-0 border-gray-200 dark:border-gray-700':
          corpTab.active,
        'bg-gray-100 dark:bg-gray-900 border border-b-0 border-gray-200 dark:border-gray-700':
          !corpTab.active
      }"
    >
      {{ corpTab.title }}
    </a>
    </li>
    }
</ul>
<ng-content></ng-content>